export const PHONE_DATA = {
  RU: {
    dialCode: '7',
    placeholder: '7 921 123-45-67',
    mask: '. ... ...-..-..',
    exceptions: {
      local: '89',
      intlWithLocal: '78',
    },
  },
  KZ: {
    dialCode: '77',
    placeholder: '7 721 123-45-67',
    mask: '. ... ...-..-..',
  },
  KG: {
    dialCode: '996',
    placeholder: '996 123-456-789',
    mask: '... ...-...-...',
  },
  TJ: {
    dialCode: '992',
    placeholder: '992 12 345 6789',
    mask: '... .. ... ....',
  },
  UZ: {
    dialCode: '998',
    placeholder: '998 12 345-67-89',
    mask: '... .. ...-..-..',
  },
  default: {
    dialCode: '',
    placeholder: '',
    mask: '.........................',
  },
};

export const MIN_LEN_PHONE_NUMBER = 10;

export const TEL_LEN_INPUT_REQ = 25;

export const NOT_NUMBER_CHAR = /\D*/g;
